<label class="form-switch">
  <input type="checkbox" [checked]="value" (change)="onToggle($event)" />
  <i></i>
  <ng-content></ng-content>
</label>
